import * as React from "react";
import PropTypes from "prop-types";
import ReactDOM from "react-dom";

// Just so it's clearer what's happening in React DevTools
const MountedOnBody = ({ children }) => children;
MountedOnBody.propTypes = {
  children: PropTypes.element,
};

export default class MountOnBody extends React.Component {
  static propTypes = {
    children: PropTypes.element,
  };

  componentDidMount() {
    this.updateRoot();
  }

  componentDidUpdate() {
    this.updateRoot();
  }

  componentWillUnmount() {
    this.unmountRoot();
  }

  ensureEl() {
    if (this.el) {
      return;
    }

    this.el = document.createElement("div");
    this.el.classList.add("mounted-on-body");
    document.body.appendChild(this.el);
  }

  mountRoot() {
    this.ensureEl();
    ReactDOM.render(
      <MountedOnBody>{this.props.children}</MountedOnBody>,
      this.el
    );
  }

  updateRoot() {
    if (this.props.children) {
      this.mountRoot();
    } else {
      this.unmountRoot();
    }
  }

  unmountRoot() {
    if (!this.el) {
      return;
    }

    ReactDOM.unmountComponentAtNode(this.el);
    if (this.el.parentNode) {
      this.el.parentNode.removeChild(this.el);
    }
    this.el = null;
  }

  render() {
    // We mount a new react root on <body> instead of rendering here.
    return null;
  }
}



// WEBPACK FOOTER //
// ../nx-components/src/MountOnBody.jsx